export const LOAD_REQUESTED = "CHECKBOX_WIDGET/LOAD_REQUESTED";
export const LOAD_SUCCESS = "CHECKBOX_WIDGET/LOAD_SUCCESS";
export const LOAD_FAIL = "CHECKBOX_WIDGET/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadCheckboxWidget = data => ({ type: LOAD_REQUESTED, data });
export const successLoadCheckboxWidget = data => ({ type: LOAD_SUCCESS, data });
export const failLoadCheckboxWidget = data => ({ type: LOAD_FAIL, data });
